import { type ReactNode } from "react";
import { Dialog } from "@/components/ui/dialog";
import { ExamDialogContent } from "./ExamDialogContent";

interface ExamConfirmationDialogProps {
  body: ReactNode;
  cancelLabel: string;
  confirmLabel: string;
  destructive?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  title: string;
}

export function ExamConfirmationDialog({
  body,
  cancelLabel,
  confirmLabel,
  destructive = false,
  onCancel,
  onConfirm,
  onOpenChange,
  open,
  title,
}: ExamConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <ExamDialogContent
        footer={
          <>
            <button
              className="h-9 rounded-lg border border-[#e0e0e0] px-4 text-sm font-semibold leading-5 text-[#0a0c11] hover:bg-[#f4f4f6]"
              onClick={onCancel}
              type="button"
            >
              {cancelLabel}
            </button>
            <button
              className={`h-9 rounded-lg px-4 text-sm font-semibold leading-5 text-white ${destructive ? "bg-[#e24b4a] hover:bg-[#cf403f]" : "bg-[var(--dp-brand-button)] hover:bg-[var(--dp-brand-hover)]"}`}
              onClick={onConfirm}
              type="button"
            >
              {confirmLabel}
            </button>
          </>
        }
        title={title}
      >
        <div className="text-base leading-6 text-[#5b616d]">{body}</div>
      </ExamDialogContent>
    </Dialog>
  );
}
